import AutosuggestResultItem from './AutosuggestResultItem'

export * from './AutosuggestResultItem'

export default AutosuggestResultItem
